import { z } from 'zod';

export const dividendSchema = z.object({
  id: z.number(),
  g_id: z.string(),
  sym_id: z.number().gte(0, {
    error: 'Symbol is required.',
  }),
  share_count: z.number(),
  amount: z.number(),
  tax: z.number(),
  zakat: z.number(),
  payment_timestamp: z.iso.datetime(),
  entry_timestamp: z.iso.datetime(),
});

export type DividendSchema = z.infer<typeof dividendSchema>;

export const dividendUpdateSchema = dividendSchema.omit({
  g_id: true,
  entry_timestamp: true,
});

export type DividendUpdateSchema = z.infer<typeof dividendUpdateSchema>;

export const dividendCreateSchema = dividendUpdateSchema.omit({
  id: true,
});

export type DividendCreateSchema = z.infer<typeof dividendCreateSchema>;

export const dividendFormSchema = dividendSchema
  .omit({
    g_id: true,
    entry_timestamp: true,
  })
  .extend({
    payment_timestamp: z.date({
      error: (issue) => (issue.input === undefined ? 'Please provide a valid transaction date.' : undefined),
    }),
    share_count: z
      .number()
      .nullable()
      .refine(
        (v) => {
          const parsed = parseInt(`${v ?? 0}`.toString());
          return !isNaN(parsed) && parsed > 0;
        },
        {
          error: 'Number of Shares must be greater than 0.',
        }
      ),
    amount: z.coerce
      .number<number>()
      .nullable()
      .refine(
        (v) => {
          const parsed = parseFloat(`${v ?? 0}`.toString());
          return !isNaN(parsed) && parsed > 0;
        },
        {
          error: 'Share price must be greater than 0.',
        }
      ),
    tax: z.coerce.number<number>().nullable(),
    zakat: z.coerce.number<number>().nullable(),
  });

export type DividendFormSchema = z.infer<typeof dividendFormSchema>;
